import { API } from '../api/common'

export default {
  methods: {
    get_link_data: function (doctype, data, txt) {
      if (!doctype) return
      data.loading = true
      // alert("Hello world")
      API.post('api/method/frappe.desk.search.search_link', {
        txt: txt ?? '',
        doctype: doctype,
        page_length: 100,
        reference_doctype: null
      })
      .then(response => {
        data.items = response.data.results.map(r => r.value)
      })
      .catch(error => {
        // this.error = error
        console.log(error)
      })
      .finally(() => data.loading = false)
    },
  }
}
